module fdm.pilotPerformance {

    interface IAxis {
        x?: Array<number>;
        y?: Array<string>;
        type?: string;
        orientation?: string;
    }

    class PilotTopEventsController {

        readonly BarWidth: number = 18;
        readonly BarGap: number = 18;

        readonly barWithGapWidth = this.BarWidth + this.BarGap;
        readonly barWidthRatio = this.BarWidth / this.barWithGapWidth;
        readonly gapWidthRatio = this.BarGap / this.barWithGapWidth;

        public queryResult: any;
        public query: any;
        public data: any;
        public layout: any;
        public options: any;
        public events: any;
        public loading: any;

        public isInitialized: boolean = false;

        public constructor(
            private actionService: dg.actions.ActionService,
            private $scope: any,
            private $element: ng.IAugmentedJQuery,
            private navigationService: dg.navigation.NavigationService,
            private chartService: dg.lists.ChartService,
            private uiService: dgUtils.UiService,
            private severityLevelService: flightEvents.SeverityLevelService) {

        }

        private yAxes: Array<IAxis> = [];
        //private yItemsPlaceholder: Array<string> = [];

        $onChanges(changes) {
            if (changes.queryResult && changes.queryResult.currentValue) {
                this.isInitialized = false;
                this.yAxes = [];
                //this.yItemsPlaceholder = [];
                this.generateChart();
            }
        }
        
        public generateChart() {
            let minorTrace = {
                x: [],
                y: [],
                name: 'Minor',
                orientation: 'h',
                type: 'bar',
                marker: {
                    color: this.severityLevelService.getColor('Minor'),
                    opacity: 0.9,
                },
                width: this.barWidthRatio,
                text: [],
                textfont: {
                    size: 16,
                    color: '#fff'
                },
                hoverinfo: 'text',
                hoverlabel: {
                    bgcolor: '#535250',
                    font: { color: 'white' }
                }
                //textposition: 'auto'

            };
            let majorTrace = {
                x: [],
                y: [],
                name: 'Major',
                orientation: 'h',
                type: 'bar',
                marker: {
                    color: this.severityLevelService.getColor('Major'),
                    opacity: 0.9,
                },
                width: this.barWidthRatio,
                text: [],
                textfont: {
                    size: 16,
                    color: '#fff'
                },
                hoverinfo: 'text',
                hoverlabel: {
                    bgcolor: '#535250',
                    font: { color: 'white' }
                }
                //textposition: 'auto',
            };
            let criticalTrace = {
                x: [],
                y: [],
                name: 'Critical',
                orientation: 'h',
                type: 'bar',
                marker: {
                    color: this.severityLevelService.getColor('Critical'),
                    opacity: 0.9,
                },
                width: this.barWidthRatio,
                text: [],
                textfont: {
                    size: 16,
                    color: '#fff'
                },
                hoverinfo: 'text',
                hoverlabel: {
                    bgcolor: '#535250',
                    font: { color: 'white' }
                }
                //textposition: 'auto'
            };

            for (let i = 0; i < this.queryResult.items.length; i += 1) {
                let item: iteraFDM.domain.pilotPerformance.PilotTopEventsInfo = <iteraFDM.domain.pilotPerformance.PilotTopEventsInfo><any>this.queryResult.items[i];
                minorTrace.x.unshift(item.minorCount);
                majorTrace.x.unshift(item.majorCount);
                criticalTrace.x.unshift(item.criticalCount);

                minorTrace.y.unshift(item.event.id + ' ');
                majorTrace.y.unshift(item.event.id + ' ');
                criticalTrace.y.unshift(item.event.id + ' ');

                minorTrace.text.unshift(`${item.event.description} (${item.minorCount})`);
                majorTrace.text.unshift(`${item.event.description} (${item.majorCount})`);
                criticalTrace.text.unshift(`${item.event.description} (${item.criticalCount})`);



                //if (item.minorCount > 0 && item.majorCount > 0) {
                //    minorTrace.text.unshift(``);
                //    majorTrace.text.unshift(``);
                //}
                //else if (item.minorCount > 0 && item.majorCount == 0 && item.criticalCount == 0) {
                //    minorTrace.text.unshift(`${item.event.description} (${item.minorCount})`);
                //}
                //else if (item.majorCount > 0 && item.minorCount == 0 && item.criticalCount == 0) {
                //    majorTrace.text.unshift(`${item.event.description} (${item.majorCount})`);
                //}

                //
            }

            ////Minor
            //if (minorTrace.x.some(n => n > 0)) {
            //    minorTrace.hoverinfo = 'x+y';
            //}

            //if (majorTrace.x.some(n => n > 0)) {
            //    majorTrace.hoverinfo = 'x+y';
            //}

            //if (criticalTrace.x.some(n => n > 0)) {
            //    criticalTrace.hoverinfo = 'x+y';
            //}

            this.data = [criticalTrace, majorTrace, minorTrace];

 

            let height = this.queryResult.items.length * this.barWithGapWidth - this.BarGap + 39;

            if (this.queryResult.items.length == 0) {
                height = 50;   
            }

            this.layout = {
                barmode: 'stack',
                showlegend: false,
                height: 150,
                hovermode: 'closest', //'closest',
                //bargap: barWidth / oneItemWithOffsetWidth,
                //bargroupgap: 0.3,
                bargap: this.gapWidthRatio,
                margin: {
                    t: 15,
                    b: 10,
                    l: 65,
                    r: 10
                },
                xaxis: {
                    fixedrange: true,
                    side: 'top',
                    automargin: true,
                    domain: [1, 100]
                },
                yaxis: {
                    //autotick: true,
                    fixedrange: true,
                    automargin: true
                }
            };
            this.options = {
                showLink: false,
                displayLogo: false,
                displayModeBar: false,
                staticPlot: false
            };

            //console.log(this.data)

            this.events = (graph) => {
                let w: any = window;

                graph.on('plotly_click', (data) => {
                    if (data.points) {  
                        let name = data.points[0].y;
                        name = name.substring(0, name.length - 1); //Getting rid of the additional space
                        let level = data.points[0].data.name;

                        // let link = this.uiService.getLinkByPropertyAndLevel('event', name, level, this.queryResult);
                        let link = this.uiService.getLinkByProperty('event', name, this.queryResult);
                        this.navigationService.navigate(link, this.query);
                    }
                });

                //graph.on('plotly_hover', (data) => {
                //    //let infotext = this.chartservice.getitembyindex(data, this.xitems, this.xitemsplaceholder);
                //    //let prop = data.points[0].y.substring(0, data.points[0].x.length - 1);
                //    //this.chartservice.setplaceholdertext(data.points[0].text, data.points[0].text);

                //    //console.log(data);
                //    //data.points[0].text = "tttttttest";
                //});


                //graph.on('plotly_hover', (eventData) => {
                //    //let infoText = this.chartService.getItemByIndex(eventData, this.xItems, this.xItemsPlaceholder);
                //    let infoText = 'ttt'
                //    this.chartService.setPlaceholderText(infoText, eventData.points[0].y);
                //});
            };
        }
    }

    angular.module('fdm.pilotPerformance').component('pilotTopEvents', {
        bindings: {
            loading: '<',
            queryResult: '<',
            query: '<'
        },
        controller: PilotTopEventsController,
        templateUrl: '/digmo/src/lists/chart/plotly-chart-instance.html'
    });
}